<template>
  <div id="lineMapWrap">
    <div id="lineTools">
      <ButtonGroup vertical>
        <Button :type="isSearch ? 'primary' : 'default'" icon="ios-search" title="搜索位置"
          @click="isSearch = !isSearch"></Button>
        <Button icon="ios-disc" title="绘制" @click="lineDraw"></Button>
        <Button icon="ios-open" title="编辑" @click="lineEdit"></Button>
        <Button icon="md-car" title="行车轨迹自动生成" @click="openForm = true"></Button>
        <Button icon="ios-paper-plane" title="路线规划生成" @click="openFormAuto = true"></Button>
        <Tooltip placement="right" max-width="330">
          <Button icon="md-help"></Button>
          <template #content>
            <div style="width: 300px;">
              <h3 style="margin-bottom: 10px">如何绘制</h3>
              <i>先选择‘开始绘制’工具（鼠标放在按钮上有提示），在需要绘制的点上单击，双击结束</i>
              <h3 style="margin-bottom: 10px;margin-top:20px;">如何修改</h3>
              <i>先选择‘开始编辑’工具，拖动边上的小圆圈即可</i>
            </div>
          </template>
        </Tooltip>
      </ButtonGroup>
    </div>
    <div id="searchAdd1" v-if="isSearch">
      <search-add @adds="reAdds"></search-add>
    </div>
    <div id="lineMap">

    </div>

    <Modal v-model="openFormAuto" title="自动规划线路" footer-hide draggable fullscreen>
      <autoLine v-if="openFormAuto" @autoData="reAutoData"></autoLine>
    </Modal>
    <Modal v-model="openForm" title="查询行车轨迹" footer-hide draggable fullscreen>
      <mapGetList v-if="openForm" ref="mapGetList" @path="rePath"></mapGetList>
    </Modal>

  </div>
</template>
<script>
var map, route;
var mouseTool;
var path = [];
var polyline;


import autoLine from "./autoLine.vue";
import mapGetList from "./mapGetList.vue"
export default {
  components: { autoLine, mapGetList },
  data() {
    return {
      center: [114, 24],
      openForm: false,
      openFormAuto: false,
      isSearch: false,
    };
  },
  methods: {

    loadMap() {
      map = new AMap.Map("lineMap", {
        resizeEnable: true,
        center: this.center,
        zoom: 10,
      });

      mouseTool = new AMap.MouseTool(map);
      //标记中心点
      //this.markerCenter();
    },
    markerCenter() {

    },
    rePath(v) {
      path = v;
      this.getDistance(v);
      this.openForm = false;
      this.drawDefaulline();
    },

    drawDefaulline() {

      this.lineClear();
      polyline = new AMap.Polyline({
        path: path,
        isOutline: true,
        outlineColor: "#ffeeff",
        borderWeight: 4,
        strokeColor: "#3366FF",
        strokeOpacity: 1,
        strokeWeight: 8,
        // 折线样式还支持 'dashed'
        strokeStyle: "solid",
        // strokeStyle是dashed时有效
        strokeDasharray: [10, 5],
        lineJoin: "round",
        lineCap: "round",
        zIndex: 50,
        bubble: true,
      });

      map.add(polyline);
      // 缩放地图到合适的视野级别
      map.setFitView([polyline]);

    },
    //接收编辑数据并转化
    reData(m) {
      path = [];
      for (let i = 0; i < m.length; i++) {
        var arr = [m[i].x, m[i].y];
        path.push(arr);
      }
      setTimeout(() => {
        this.drawDefaulline();
      }, 500);

    },
    lineClose() {
      map.setDefaultCursor("");
      this._polygonEditor.close();
    },
    lineClear() {
      map.clearMap();
      // var polyArr = map.getAllOverlays("polyline");
      //map.remove(polyArr);
    },
    lineDraw() {
      map.setDefaultCursor("crosshair");
      mouseTool.close(true);
      this.lineClear();
      mouseTool.polyline({
        strokeColor: "#3366FF",
        strokeOpacity: 1,
        strokeWeight: 4,
        // 线样式还支持 'dashed'
        strokeStyle: "solid",
        // strokeStyle是dashed时有效
        // strokeDasharray: [10, 5],
      });

      var that = this;
      mouseTool.on("draw", function (event) {
        map.setDefaultCursor("");
        // path = [];
        path = event.obj.getPath();
        mouseTool.close(true);
        that.drawDefaulline();
        that.getDistance();
      });
    },
    getPoints() {
      if (!polyline) {
        this.$Message.error("请绘制网格");
        return;
      }

      var myPath = [];
      if (this.drawModal == "自动规划") {
        myPath = route.getRoute();
        //myPath = route.getPoint();
      } else {
        myPath = polyline.getPath();
      }
      var arr = [];
      for (var i = 0; i < myPath.length; i++) {
        var obj = {
          x: myPath[i].lng,
          y: myPath[i].lat,
        };
        arr.push(obj);
      }
      return arr;
    },
    lineEdit() {

      //this.index = 3;
      this.lineClear();
      this.drawDefaulline();
      //var that = this;
      //map.setDefaultCursor("crosshair");
      if (path.length == 0) {
        return;
      }
      var polyEditor = new AMap.PolylineEditor(map, polyline);
      polyEditor.setTarget(polyline);
      polyEditor.open();
      return;
      //this._polygonEditor.close();
      this._polygonEditor.on("adjust", function (event) {
        that.getDistance();
      });
      this._polygonEditor.on("removenode", function (event) {
        that.getDistance();
      });
    },
    getDistance() {
      var dis = AMap.GeometryUtil.distanceOfLine(path);
      this.$emit("dis", Math.floor(dis));
    },
    reAdds(v) {
      this.center = [v.x, v.y];
      map.panTo(this.center);
      map.setZoom(17);
    },
    reAutoData(v) {
      this.openFormAuto = false;
      path = v;
      this.getDistance(v);
      this.drawDefaulline();
    },
    destroyMap() {
      map && map.destroy();
    }

  },
  mounted() {
    //this.loadMap();
  },
};
</script>
<style lang="">
#lineMapWrap{
  width: 100%;
  height: 100%;
  background: #cccf;
  position: relative;
}
#lineMap {
  width: 100%;
  height: 100%;
}
#lineTools {
  position: absolute;
  background: #ccc;
  z-index: 2;
  top: 10px;
  left: 10px;
}
#searchAdd1 {
  position: absolute;
  background: #ccc;
  z-index: 2;
  top: 10px;
  left: 50px;
}

#dsewecserr .ivu-modal-body {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/map20/xianlu.vue